import React from "react";

const Loader = () => <div className="loader mini-loader" />;

export { Loader };
